import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class ContractAlertsService {

  constructor(private bringozToastService: BringozToastService) {
  }

  // CREATE //
  createSuccess() {
    const message = {
      body: 'CONTRACT_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }


  createError() {
    const message = {
      body: 'CONTRACT_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE //
  updateSuccess() {
    const message = {
      body: 'CONTRACT_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateError() {
    const message = {
      body: 'CONTRACT_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // ASSIGN //
  assignSuccess() {
    const message = {
      body: 'CONTRACT_ASSIGN_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  assignError() {
    const message = {
      body: 'CONTRACT_ASSIGN_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  removeAccountSuccess() {
    const message = {
      body: 'CONTRACT_REMOVE_CARRIER_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  removeAccountError() {
    const message = {
      body: 'CONTRACT_REMOVE_CARRIER_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // DELETE //
  deleteSuccess() {
    const message = {
      body: 'CONTRACT_DELETE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  deleteError() {
    const message = {
      body: 'CONTRACT_DELETE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // CREATE //
  addSettelmentSuccess() {
    const message = {
      body: 'ADD_SETTLEMENT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  addSettelmentError() {
    const message = {
      body: 'ADD_SETTLEMENT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  removeProgramFromContractSuccess() {
    const message = {
      body: 'REMOVE_SETTLEMENT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  removeProgramFromContractError() {
    const message = {
      body: 'REMOVE_SETTLEMENT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  setAsDefaultSuccess() {
    const message = {
      body: 'SET_CONTRACT_AS_DEFAULT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  setAsDefaultError() {
    const message = {
      body: 'SET_CONTRACT_AS_DEFAULT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }
}

angular
  .module('bringoz.admin.contracts')
  .service('contractAlertsService', ContractAlertsService);
